// removed by extract-text-webpack-plugin
module.exports = {"container":"GroupSelection__container___1qR2m","card-group":"GroupSelection__card-group___1A0Kf","primary-button":"GroupSelection__primary-button___1m9T5"};